import React, { useState } from 'react';
import './HelpTooltip.css';

interface HelpTooltipProps {
  children: React.ReactNode;
  helpText?: string;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ children, helpText }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!helpText) {
    return <>{children}</>;
  }

  return (
    <span
      className="help-tooltip"
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
      onFocus={() => setIsExpanded(true)}
      onBlur={() => setIsExpanded(false)}
      tabIndex={0}
    >
      <span className="help-tooltip__label">{children}</span>
      <span className={`help-tooltip__text ${isExpanded ? 'help-tooltip__text--visible' : ''}`}>
        {helpText}
      </span>
    </span>
  );
};

export default HelpTooltip;
